import React from 'react';

export function UnSplitLineColumnFormatter(id, unsplitReceiptLine) {

  return <div onClick={() => unsplitReceiptLine(id)} style={{fontSize: '16px', cursor: 'pointer'}}>⬆️</div>
}
